module.exports = "/_next/static/images/7a8f9828329d5705471a06b7292f45c7-mockup-transfer-fgts@1x.jpg";